export const TicketData = [
  {
    id: 1,
    locID: 2,
    showDate: "2023-03-12",
    selected: false,
    availableMovies: [
      {
        movieSynopsis: null,
        movie_id: 1349,
        movie_title: "Avatar: The Way of Water (3D)",
        director_name: "James Cameron",
        rating: "0.0",
        movie_length: "3h 12m",
        category: "3D",
        actor: "Michelle Yeoh,Zoe Saldana",
        genre: "Action,Adventure",
        language: "English",
        release: "2022-12-16",
        cover_image: "https://image.cineplexbd.com/movies/165829932793533.webp",
        profile_image:
          "https://image.cineplexbd.com/movies/165829932728231.webp",
        trailer_url: "https://www.youtube.com/watch?v=d9MyW72ELq0",
      },
      {
        movieSynopsis: null,
        movie_id: 1381,
        movie_title: "Ant-Man and the Wasp: Quantumania (3D)",
        director_name: "Peyton Reed",
        rating: "0.0",
        movie_length: "2h 05m",
        category: "3D",
        actor: "Paul Rudd, Evangeline Lilly ,Jonathan Majors",
        genre: "Action,Adventure,Comedy",
        language: "English",
        release: "2023-02-17",
        cover_image: "https://image.cineplexbd.com/movies/166824912863902.webp",
        profile_image:
          "https://image.cineplexbd.com/movies/166824912850887.webp",
        trailer_url: "https://www.youtube.com/watch?v=ZlNFpri-Y40",
      },
      {
        movieSynopsis: null,
        movie_id: 1412,
        movie_title: "MEGAN",
        director_name: "Gerard Johnstone",
        rating: "0.0",
        movie_length: "102 Min",
        category: "2D",
        actor: "Allison Williams, Violet McGraw",
        genre: "Thriller,Horror,Sci-Fi",
        language: "English",
        release: "2023-02-03",
        cover_image: "https://image.cineplexbd.com/movies/167332825226148.webp",
        profile_image:
          "https://image.cineplexbd.com/movies/167525508488392.webp",
        trailer_url: "https://www.youtube.com/watch?v=BRb4U99OU80",
      },
    ],
  },
  {
    id: 2,
    locID: 2,
    showDate: "2023-03-13",
    selected: false,
    availableMovies: [
      {
        movieSynopsis: null,
        movie_id: 1349,
        movie_title: "Avatar: The Way of Water (3D)",
        director_name: "James Cameron",
        rating: "0.0",
        movie_length: "3h 12m",
        category: "3D",
        actor: "Michelle Yeoh,Zoe Saldana",
        genre: "Action,Adventure",
        language: "English",
        release: "2022-12-16",
        cover_image: "https://image.cineplexbd.com/movies/165829932793533.webp",
        profile_image:
          "https://image.cineplexbd.com/movies/165829932728231.webp",
        trailer_url: "https://www.youtube.com/watch?v=d9MyW72ELq0",
      },
      {
        movieSynopsis: null,
        movie_id: 1381,
        movie_title: "Ant-Man and the Wasp: Quantumania (3D)",
        director_name: "Peyton Reed",
        rating: "0.0",
        movie_length: "2h 05m",
        category: "3D",
        actor: "Paul Rudd, Evangeline Lilly ,Jonathan Majors",
        genre: "Action,Adventure,Comedy",
        language: "English",
        release: "2023-02-17",
        cover_image: "https://image.cineplexbd.com/movies/166824912863902.webp",
        profile_image:
          "https://image.cineplexbd.com/movies/166824912850887.webp",
        trailer_url: "https://www.youtube.com/watch?v=ZlNFpri-Y40",
      },
      {
        movieSynopsis: null,
        movie_id: 1412,
        movie_title: "MEGAN",
        director_name: "Gerard Johnstone",
        rating: "0.0",
        movie_length: "102 Min",
        category: "2D",
        actor: "Allison Williams, Violet McGraw",
        genre: "Thriller,Horror,Sci-Fi",
        language: "English",
        release: "2023-02-03",
        cover_image: "https://image.cineplexbd.com/movies/167332825226148.webp",
        profile_image:
          "https://image.cineplexbd.com/movies/167525508488392.webp",
        trailer_url: "https://www.youtube.com/watch?v=BRb4U99OU80",
      },
      {
        movieSynopsis: null,
        movie_id: 1414,
        movie_title: "What's Love Got to Do with It",
        director_name: "Shekhar Kapur",
        rating: "0.0",
        movie_length: "108 Min",
        category: "2D",
        actor: "Emma Thompson, Lily James",
        genre: "Romantic,Comedy",
        language: "English",
        release: "2023-03-03",
        cover_image: "https://image.cineplexbd.com/movies/167333167917766.webp",
        profile_image:
          "https://image.cineplexbd.com/movies/167333167970037.webp",
        trailer_url: "https://www.youtube.com/watch?v=0LqOp2MNwao",
      },
    ],
  },
  {
    id: 3,
    locID: 2,
    showDate: "2023-03-14",
    selected: false,
    availableMovies: [
      {
        movieSynopsis: null,
        movie_id: 1349,
        movie_title: "Avatar: The Way of Water (3D)",
        director_name: "James Cameron",
        rating: "0.0",
        movie_length: "3h 12m",
        category: "3D",
        actor: "Michelle Yeoh,Zoe Saldana",
        genre: "Action,Adventure",
        language: "English",
        release: "2022-12-16",
        cover_image: "https://image.cineplexbd.com/movies/165829932793533.webp",
        profile_image:
          "https://image.cineplexbd.com/movies/165829932728231.webp",
        trailer_url: "https://www.youtube.com/watch?v=d9MyW72ELq0",
      },
      {
        movieSynopsis: null,
        movie_id: 1381,
        movie_title: "Ant-Man and the Wasp: Quantumania (3D)",
        director_name: "Peyton Reed",
        rating: "0.0",
        movie_length: "2h 05m",
        category: "3D",
        actor: "Paul Rudd, Evangeline Lilly ,Jonathan Majors",
        genre: "Action,Adventure,Comedy",
        language: "English",
        release: "2023-02-17",
        cover_image: "https://image.cineplexbd.com/movies/166824912863902.webp",
        profile_image:
          "https://image.cineplexbd.com/movies/166824912850887.webp",
        trailer_url: "https://www.youtube.com/watch?v=ZlNFpri-Y40",
      },
      {
        movieSynopsis: null,
        movie_id: 1412,
        movie_title: "MEGAN",
        director_name: "Gerard Johnstone",
        rating: "0.0",
        movie_length: "102 Min",
        category: "2D",
        actor: "Allison Williams, Violet McGraw",
        genre: "Thriller,Horror,Sci-Fi",
        language: "English",
        release: "2023-02-03",
        cover_image: "https://image.cineplexbd.com/movies/167332825226148.webp",
        profile_image:
          "https://image.cineplexbd.com/movies/167525508488392.webp",
        trailer_url: "https://www.youtube.com/watch?v=BRb4U99OU80",
      },
      {
        movieSynopsis: null,
        movie_id: 1414,
        movie_title: "What's Love Got to Do with It",
        director_name: "Shekhar Kapur",
        rating: "0.0",
        movie_length: "108 Min",
        category: "2D",
        actor: "Emma Thompson, Lily James",
        genre: "Romantic,Comedy",
        language: "English",
        release: "2023-03-03",
        cover_image: "https://image.cineplexbd.com/movies/167333167917766.webp",
        profile_image:
          "https://image.cineplexbd.com/movies/167333167970037.webp",
        trailer_url: "https://www.youtube.com/watch?v=0LqOp2MNwao",
      },
    ],
  },
  {
    id: 4,
    locID: 2,
    showDate: "2023-03-15",
    selected: false,
    availableMovies: [
      {
        movieSynopsis: null,
        movie_id: 1349,
        movie_title: "Avatar: The Way of Water (3D)",
        director_name: "James Cameron",
        rating: "0.0",
        movie_length: "3h 12m",
        category: "3D",
        actor: "Michelle Yeoh,Zoe Saldana",
        genre: "Action,Adventure",
        language: "English",
        release: "2022-12-16",
        cover_image: "https://image.cineplexbd.com/movies/165829932793533.webp",
        profile_image:
          "https://image.cineplexbd.com/movies/165829932728231.webp",
        trailer_url: "https://www.youtube.com/watch?v=d9MyW72ELq0",
      },
      {
        movieSynopsis: null,
        movie_id: 1381,
        movie_title: "Ant-Man and the Wasp: Quantumania (3D)",
        director_name: "Peyton Reed",
        rating: "0.0",
        movie_length: "2h 05m",
        category: "3D",
        actor: "Paul Rudd, Evangeline Lilly ,Jonathan Majors",
        genre: "Action,Adventure,Comedy",
        language: "English",
        release: "2023-02-17",
        cover_image: "https://image.cineplexbd.com/movies/166824912863902.webp",
        profile_image:
          "https://image.cineplexbd.com/movies/166824912850887.webp",
        trailer_url: "https://www.youtube.com/watch?v=ZlNFpri-Y40",
      },
      {
        movieSynopsis: null,
        movie_id: 1412,
        movie_title: "MEGAN",
        director_name: "Gerard Johnstone",
        rating: "0.0",
        movie_length: "102 Min",
        category: "2D",
        actor: "Allison Williams, Violet McGraw",
        genre: "Thriller,Horror,Sci-Fi",
        language: "English",
        release: "2023-02-03",
        cover_image: "https://image.cineplexbd.com/movies/167332825226148.webp",
        profile_image:
          "https://image.cineplexbd.com/movies/167525508488392.webp",
        trailer_url: "https://www.youtube.com/watch?v=BRb4U99OU80",
      },
      {
        movieSynopsis: null,
        movie_id: 1414,
        movie_title: "What's Love Got to Do with It",
        director_name: "Shekhar Kapur",
        rating: "0.0",
        movie_length: "108 Min",
        category: "2D",
        actor: "Emma Thompson, Lily James",
        genre: "Romantic,Comedy",
        language: "English",
        release: "2023-03-03",
        cover_image: "https://image.cineplexbd.com/movies/167333167917766.webp",
        profile_image:
          "https://image.cineplexbd.com/movies/167333167970037.webp",
        trailer_url: "https://www.youtube.com/watch?v=0LqOp2MNwao",
      },
    ],
  },
  {
    id: 5,
    locID: 2,
    showDate: "2023-03-16",
    selected: false,
    availableMovies: [
      {
        movieSynopsis: null,
        movie_id: 1349,
        movie_title: "Avatar: The Way of Water (3D)",
        director_name: "James Cameron",
        rating: "0.0",
        movie_length: "3h 12m",
        category: "3D",
        actor: "Michelle Yeoh,Zoe Saldana",
        genre: "Action,Adventure",
        language: "English",
        release: "2022-12-16",
        cover_image: "https://image.cineplexbd.com/movies/165829932793533.webp",
        profile_image:
          "https://image.cineplexbd.com/movies/165829932728231.webp",
        trailer_url: "https://www.youtube.com/watch?v=d9MyW72ELq0",
      },
      {
        movieSynopsis: null,
        movie_id: 1381,
        movie_title: "Ant-Man and the Wasp: Quantumania (3D)",
        director_name: "Peyton Reed",
        rating: "0.0",
        movie_length: "2h 05m",
        category: "3D",
        actor: "Paul Rudd, Evangeline Lilly ,Jonathan Majors",
        genre: "Action,Adventure,Comedy",
        language: "English",
        release: "2023-02-17",
        cover_image: "https://image.cineplexbd.com/movies/166824912863902.webp",
        profile_image:
          "https://image.cineplexbd.com/movies/166824912850887.webp",
        trailer_url: "https://www.youtube.com/watch?v=ZlNFpri-Y40",
      },
      {
        movieSynopsis: null,
        movie_id: 1412,
        movie_title: "MEGAN",
        director_name: "Gerard Johnstone",
        rating: "0.0",
        movie_length: "102 Min",
        category: "2D",
        actor: "Allison Williams, Violet McGraw",
        genre: "Thriller,Horror,Sci-Fi",
        language: "English",
        release: "2023-02-03",
        cover_image: "https://image.cineplexbd.com/movies/167332825226148.webp",
        profile_image:
          "https://image.cineplexbd.com/movies/167525508488392.webp",
        trailer_url: "https://www.youtube.com/watch?v=BRb4U99OU80",
      },
      {
        movieSynopsis: null,
        movie_id: 1414,
        movie_title: "What's Love Got to Do with It",
        director_name: "Shekhar Kapur",
        rating: "0.0",
        movie_length: "108 Min",
        category: "2D",
        actor: "Emma Thompson, Lily James",
        genre: "Romantic,Comedy",
        language: "English",
        release: "2023-03-03",
        cover_image: "https://image.cineplexbd.com/movies/167333167917766.webp",
        profile_image:
          "https://image.cineplexbd.com/movies/167333167970037.webp",
        trailer_url: "https://www.youtube.com/watch?v=0LqOp2MNwao",
      },
    ],
  },
];

export const WeeklyName = ({ name }) => {
  const date = new Date(name);
  const weekNames = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const weekName = weekNames[date.getDay()];
  return weekName;
};
export const MonthName = ({ name }) => {
  const date = new Date(name);

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const monthName = monthNames[date.getMonth()];
  return monthName;
};

export const DateName = ({ name }) => {
  const date = new Date(name);
  const day = date.getDate();

  return day;
};
